import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ServiceDto } from '../models/servicedto';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  private url_all_currency = '';
  private url_create_currency = '';
  private url_update_currency = '';
  private url_delete_currency = '';



  constructor(private http: HttpClient, private configService: AppConfigService) {
    this.url_all_currency = this.configService.apiUrl + '/configuration/currency/listAll';
    this.url_create_currency = this.configService.apiUrl + '/configuration/currency/insert';
    this.url_update_currency = this.configService.apiUrl + '/configuration/currency/update/true';
    this.url_delete_currency = this.configService.apiUrl + '/configuration/currency/delete/';
  }

  getAllCurrency(): Observable<any> {
    return this.http.get<any>(this.url_all_currency);
  }

  createCurrency(service: ServiceDto): Observable<any> {
    return this.http.post<any>(this.url_create_currency, service);
  }

  updateCurrency(service: ServiceDto): Observable<any> {
    return this.http.put<any>(this.url_update_currency, service);
  }

  deleteCurrency(serviceCode: number | null) {
    return this.http.delete<any>(this.url_delete_currency + serviceCode);
  }
}
